module.exports = __webpack_public_path__ + "img/white-b-case-closed-xbox.ec544385.svg";